import WorksPane from '../Works/WorksPane.js';

/**
 * Homepage projects showcase.
 *
 * The pinned works pane: one project at a time, selected by scroll position
 * within the section's pinned range, with a generative glyph standing in for
 * each project and a Work/Personal split.
 *
 * Replaces THE LEDGER (#13). That rendition and the two alternatives it was
 * chosen against lived at /lab, which has been retired now that the question
 * it existed to answer is settled.
 */
export const Projects = () => <WorksPane id='projects' />;
